declare global {
  interface Window {
    AZURE_CLIENT_ID: string;
    AZURE_TENANT_ID: string;
    CX_DEPLOY_ENV: string;
    IS_DISABLE_LOG: string;
    API_URL: string;
    API_HOST: string;
    PUBLIC_URL: string;
  }
}

const serverConfig = {
  azure: {
    clientId: window.AZURE_CLIENT_ID || '61f90bf0-d691-469f-a95b-ae3eaa305393',
    tenantId: window.AZURE_TENANT_ID || '4266ec6c-fe9f-4893-82e9-996189e0b81b',
  },
  environment: window.CX_DEPLOY_ENV || 'local',
  isDev: window.CX_DEPLOY_ENV !== 'p0',
  isDisableLog: window.IS_DISABLE_LOG === 'true' || false,
  apiHost: window.API_HOST || '/fcopy/api/1.0',
  publicURL: window.PUBLIC_URL || '',
  apiURL: window.API_URL || '',
};

export default serverConfig;
